<template>
  <!-- Schutzgerüste-->
  <span v-for="(geruest, index) in getSchutzgerueste(ba)" :key="index">
    <pdf-a-4-page no-margin :pdf-key="lang">
      <div class="landingpage-background w-screen h-screen">
        <div class="flex flex-col justify-between" style="height:1020px">
          <tng-header :ba="ba" :immobilie="immobilie" :lang="lang"/>
          <div class="text-xs text-gray-500 mt-5">Schutzgerüste > Schutzgerüst {{ index + 1 }}</div>

            <div class="h-full max-h-full">
              <div class="text-xl md:text-xl font-bold">Schutzgerüst {{ index + 1 }}</div>
              <div
                class="grid grid-cols-8 justify-items-stretch items-center gap-y-3"
              >
                <div
                  class="col-span-2 text-sm font-bold"
                  style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
                >
                  Frage
                </div>
                <div
                  class="text-sm font-bold col-span-5"
                  style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
                >
                  Beschreibung/Eingabewerte
                </div>
                <div
                  class="col-span- text-sm font-bold"
                  style="border-style:solid;border-color:white white rgb(216,215,26); border-radius: 5px;"
                >
                  Bewertung
                </div>

                <div class="text-xs col-span-2">Betroffene Flurstücke</div>
                <div class="col-span-5 text-xs text-gray-500">{{ geruest.findFrageByRelativePath(ba, 'betroffeneflurstuecke')?.getCurrentInput()  }}</div>

                <div class="text-xs col-span-2">Typ</div>
                <div class="col-span-5 text-xs text-gray-500">{{ geruest.findFrageByRelativePath(ba, 'typ')?.getSelectedAuswahlLabelsString()  }}</div>

                <div class="text-xs col-span-2">Zu schützendes Objekt - Art</div>
                <div class="col-span-5 text-xs text-gray-500">{{ geruest.findFrageByRelativePath(ba, 'schuetzendes-objekt-art')?.getCurrentInput()  }}</div>

                <div class="text-xs col-span-2">Zu schützendes Objekt - Abmessung</div>
                <div class="col-span-5 text-xs text-gray-500">{{ geruest.findFrageByRelativePath(ba, 'schuetzendes-objekt-abmessung')?.getCurrentInput() }}</div>

                <div class="text-xs col-span-7">Zu schützendes Objekt - Bewertung</div>
                <bewertung-chip
                  :fragenblock="geruest"
                  fragesPath="schuetzendes-objekt-bewertung"
                  :ba="ba"
                  :immobilie="immobilie"
                  :lang="lang"
                  class="justify-self-end"
                />

                <div class="text-xs col-span-2">Länge des Schutzgerüstes</div>
                <div class="col-span-5 text-xs text-gray-500">
                  {{ 
                    geruest.findFrageByRelativePath(ba, 'laenge-schutzgeruest')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(ba, 'laenge-schutzgeruest')?.getCurrentInput() + " m" 
                      : "-" 
                  }}
                </div>
                <bewertung-chip
                  :fragenblock="geruest"
                  fragesPath="laenge-schutzgeruest-bewertung"
                  :ba="ba"
                  :immobilie="immobilie"
                  :lang="lang"
                  class="justify-self-end"
                />


                <div class="text-xs col-span-2">Breite der geplanten Gerüstwände</div>
                <div class="col-span-5 text-xs text-gray-500">
                  {{ 
                    geruest.findFrageByRelativePath(ba, 'breite-geruestwaende')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(ba, 'breite-geruestwaende')?.getCurrentInput() + " m" 
                      : "-" 
                  }}
                </div>
                <bewertung-chip
                  :fragenblock="geruest"
                  fragesPath="breite-geruestwaende-bewertung"
                  :ba="ba"
                  :immobilie="immobilie"
                  :lang="lang"
                  class="justify-self-end"
                />


                <div class="text-xs col-span-2">Höhe Gerüstwände</div>
                <div class="col-span-5 text-xs text-gray-500">
                  {{ 
                    geruest.findFrageByRelativePath(ba, 'hoehe-geruestwaende')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(ba, 'hoehe-geruestwaende')?.getCurrentInput() + " m" 
                      : "-" 
                  }}
                </div>
                <bewertung-chip
                  :fragenblock="geruest"
                  fragesPath="hoehe-geruestwaende-bewertung"
                  :ba="ba"
                  :immobilie="immobilie"
                  :lang="lang"
                  class="justify-self-end"
                />


                <div class="text-xs col-span-2">Spannweite des Netzes</div>
                <div class="col-span-5 text-xs text-gray-500">
                  {{ 
                    geruest.findFrageByRelativePath(ba, 'spannweite-netz')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(ba, 'spannweite-netz')?.getCurrentInput() + " m" 
                      : "-" 
                  }}
                </div>
                <bewertung-chip
                  :fragenblock="geruest"
                  fragesPath="spannweite-netz-bewertung"
                  :ba="ba"
                  :immobilie="immobilie"
                  :lang="lang"
                  class="justify-self-end"
                />

                <is-vorhanden-char-and-label
                :fragenblock="geruest"
                :ba="ba"
                fragesPath="entfernung-hoehe-geruestwaende"
                label="Entfernung der Abspannung entpricht der Höhe der Gerüstwand"
                class="col-span-7"
                />
                <bewertung-chip
                  :fragenblock="geruest"
                  fragesPath="entfernung-hoehe-geruestwaende-bewertung"
                  :ba="ba"
                  :immobilie="immobilie"
                  :lang="lang"
                  class="justify-self-end"
                />


                <div class="text-xs col-span-2">Abstand zur bestehenden/geplanten überkreuzenden Freileitung</div>
                <div class="col-span-5 text-xs text-gray-500">
                  {{ 
                    geruest.findFrageByRelativePath(ba, 'abstand-freileitung')?.getCurrentInput() 
                      ? geruest.findFrageByRelativePath(ba, 'abstand-freileitung')?.getCurrentInput() + " m" 
                      : "-" 
                  }}
                </div>
                <bewertung-chip
                  :fragenblock="geruest"
                  fragesPath="abstand-freileitung-bewertung"
                  :ba="ba"
                  :immobilie="immobilie"
                  :lang="lang"
                  class="justify-self-end"
                />  
              </div>
            </div>      
            <be-footer :ba="ba" :immobilie="immobilie" :lang="lang"/>
        </div>
      </div>
    </pdf-a-4-page>
  </span>
</template>

<script lang="ts">
import useUser from '@/composables/useUser';
import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
import Immobilie from '@/models/immobilie.model';
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import moment from 'moment';
import { useIdentifierFrageFinder,getAuswahlLabel } from '@/composables/Bestandsaufnahme/useIdentifierFinder';
import { getPhotoUrl } from '@/utilities/get-media-url';
import PdfA4Page from '@/components/Pdf/Components/PdfA4Page.vue';
import PdfChip from '../Components/PdfChip.vue';
import UniversalPdfImageRow from '../Components/UniversalPdfImageRow.vue';
import OnetoFiveImageDivMehrfach from './PageElements/OnetoFiveImageDivMehrfach.vue';
import OnetoFiveImageDiv from './PageElements/OnetoFiveImageDiv.vue';
import TngHeader from './PageElements/TngHeader.vue';
import BeFooter from './PageElements/BeFooter.vue';
import BewertungChip from './PageElements/BewertungChipMehrfach.vue';
import { useGesamtflaechen } from './PageElements/useGesamtflaechen';
import IsVorhandenCharAndLabel from './PageElements/isVorhandenCharAndLabelMehrfach.vue';
export default defineComponent( {
  name: 'Schutzgerueste',
  components: {
    PdfA4Page,
    PdfChip,
    UniversalPdfImageRow,
    TngHeader,
    OnetoFiveImageDivMehrfach,
    OnetoFiveImageDiv,
    BewertungChip,
    BeFooter,
    IsVorhandenCharAndLabel
  },
  props: {
    ba: {
      type: Object as PropType<Bestandsaufnahme>,
      required: true,
    },
    immobilie: {
      type: Object as PropType<Immobilie>,
      required: true,
    },
    lang: {
      type: String,
      default: 'de',
    },
  },
  setup ( props: any ) {
    const { t } = useI18n( { useScope: 'global' } );
    const uUser = useUser();
    const { getSchutzgerueste } = useGesamtflaechen();
    return {
      user: uUser.user,
      t,
      useIdentifierFrageFinder,
      moment,
      getPhotoUrl,
      getSchutzgerueste,
      getAuswahlLabel,
    };
  },
} );
</script>
<style scoped>
  * {
    color: rgb(23,68,81);
    font-family: var(--secondaryFont);
  }
  
  .pdf-content {
    width: 800px;
    margin: 0 auto;
    color: white;
  }
  
  .landingpage-background {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 700px;
    height: 1050px;
    color: black;
  }
  
  .trenner {
    height: 1px;
    border-width: 0;
    color: black;
    background-color: black;
  }
  
  .content {
    height: 870px;
  }
</style>
